/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import './EpikboxOptions.css';
import { Button, Col, Row, Tooltip, Input, Label, Alert, FormGroup } from 'reactstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import DropdownSelect from '../../../../ProposalGenerator/DropdownSelect';
import AddSecurityCodeModal from '../../../../AddSecurityCodeModal';
import CustomModal from '../../../../CustomModal';
import * as BoxesActions from '../../../../../actions/EpikBoxes';
import SpinnerCircles from '../../../../Spinner/SpinerCircles';
import MultiInputDrag from '../../../../MultiInputDrag';
import BoxAutocomplete from '../../../BoxAutocomplete';
import { clearAddress, getAddress, updateAddress } from '../../../../../actions/Provisioning';
import E911AddressModal from '../../../../E911AddressModal';
import ConfirmationModal from '../../../../ConfirmationModal';
import Toggle from '../../../../Toggle';
import {
  addAction,
  changeAction,
  enableAction,
  disableAction,
} from '../../../../../actions/BoxSessionLogging';
import Spinner from '../../../../Spinner/Spinner';
import DynamicAutoComplete from '../../../DynamicAutoComplete';
import utils from '../../../../../lib/utils';
import { DATA_LATENCY_TYPE, TOOLTIPS_TEXT } from '../../../../../lib/constants';

import { obisToPort } from '../EpikBoxPorts';
import WarningModal from '../../../../WarningModal';
import InfoPopup from '../../../../InfoPopup';
import EnhancedRouting from './EnhanceRouting';
import BoxRegistrar from './BoxRegistrar';
import powerCycle from '../../../../../Res/Icon/Power-Cycle.svg';
import save from '../../../../../Res/Icon/Save.svg';
import softReboot from '../../../../../Res/Icon/Soft-Reboot.svg';
import applyUpdates from '../../../../../Res/Icon/Firmware.svg';
import suspend from '../../../../../Res/Icon/Suspend-Service.svg';
import BandManagementWarningModal from '../../../../BandManagementWarningModal';
import { set } from 'lodash';
import { PIN_CODES_NAME } from '../../../../../utils/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const APNItems = [
  { label: 'Select Carrier', value: '' },
  { label: 'Verizon', value: 'verizon' },
  { label: 'T-Mobile', value: 'tmobile' },
  { label: 'Telus', value: 'telus' },
  { label: 'AT&T', value: 'atnt' },
];
const carrierAPNs = {
  verizon: [
    { label: 'Select any APN', value: '' },
    { label: 'Custom', value: 'custom' },
    { label: 'ne01.vzwstatic', value: 'ne01.vzwstatic' },
    { label: 'we01.vzwstatic', value: 'we01.vzwstatic' },
    { label: 'mw01.vzwstatic', value: 'mw01.vzwstatic' },
    { label: 'vzwinternet', value: 'vzwinternet' },
    { label: 'GRTEPIKE.VZWENTP', value: 'GRTEPIKE.VZWENTP' },
    { label: 'GRTEPIKC.VZWENTP', value: 'GRTEPIKC.VZWENTP' },
    { label: 'GRTEPIKW.VZWENTP', value: 'GRTEPIKW.VZWENTP' },
  ],
  tmobile: [
    { label: 'Select any APN', value: '' },
    { label: 'Custom', value: 'custom' },
    { label: 'iot.granite.static', value: 'iot.granite.static' },
    { label: 'b2b.static', value: 'b2b.static' },
    { label: 'fast.t-mobile.com', value: 'fast.t-mobile.com' },
  ],
  telus: [
    { label: 'Select any APN', value: '' },
    { label: 'Custom', value: 'custom' },
    { label: 'pse.telus.iot', value: 'pse.telus.iot' },
  ],
  atnt: [
    { label: 'Select any APN', value: '' },
    { label: 'Custom', value: 'custom' },
    { label: '11166.mcs', value: '11166.mcs' },
  ],
};
const SIMItems = [{ label: 'SIM 1', value: 'BackUp' }, { label: 'SIM2', value: 'Primary' }];
const datacenters = [
  { label: 'Los Angeles', value: 'la' },
  { label: 'Chicago', value: 'ch' },
  { label: 'New York', value: 'ny', disabledItem: false },
  { label: 'Atlanta', value: 'at', disabledItem: false },
];

const warningText = {
  msg: `*Client must have address for their edge device set to:
IP: 172.17.17.100
mask: 255.255.255.0
gateway: 172.17.17.254
or system will not connect.`,
  type: 'E2',
};

const datacenterWarningText = {
  header: "Device Registration",
  subHeader: ``,
  msg:
    'This action is service affecting. Once complete, ensure the device is online by verifying ping. Faxing services will be migrated to Enhanced Fax Protocol. Fax services may be disrupted during the move process.',
  type: 'datacenter',
};

const warningMonitoringTxt = {
  msg:
    'Warning: Do Not Enable monitoring if the EPIK Edge Device is not confirmed online or the Turn up has not been completed and all tests passed. Doing so could generate false alerts. Are you sure want to proceed?',
  type: 'monitoring',
};

const warningEnhancedFax = {
  msg:
    'Warning: Enabling to Enhanced Fax Service will cause disruption to current Fax services. Are you sure you want to continue?',
  type: 'enhancedFax',
};

const warningDisableEnhancedFax = {
  msg:
    'Disabling Enhanced Fax will disrupt fax capabilities and all enhanced functionality. Please consult with engineering before proceeding. Are you sure you want to proceed with Disabling Enhanced Fax?',
  type: 'disableEnhancedFax',
};

const warningAdvancedMonitoringTxt = {
  msg:
    'Attention: Do no enable Advanced Monitoring without prior authorization from Tier 3 support. Advanced Monitoring could cause high bandwidth utilization if running on 4G LTE. Are you sure you want to Proceed?',
  type: 'advancedMonitoring',
};

const warningHardReset = {
  msg:
    'Are you sure you want to perform a hard reset? This will interrupt service on the device until the reboot cycle is complete',
  type: 'hardReset',
};

const suspendedTxt = {
  msg:
    'WARNING: Suspending service will shut off all services to the EPIK Edge Device. Are you sure you want to continue?',
  type: 'suspension1',
};

const suspendedTxt1 = {
  msg: 'Are you sure you want to proceed with service suspension?',
  type: 'suspension2',
};

const restoreSuspension = {
  msg: 'Service will be restored to the Edge device. Are you sure you want to continue?',
  type: 'restore',
};

const secondarySwitch = {
  type: 'secondary',
};

/* CONSTANTS */
const IGNORE_INFO_TOASTER = true;
const SIXTY_SECONDS_DELAY = 60_000;
const BAND_MANAGEMENT = 'bandManagement'
const DATA_CENTER = 'datacenter'
const omitLeading9 = "omitLeading9"

const EpikboxOptions = ({
  box,
  onConfirm,
  editOptionsChange,
  optionsBoxChange,
  setInterfacePriority,
  boxHardReset,
  getInterfacePriority,
  advancedMonitoring,
  priStatusCheck,
  advMonitoring,
  enableToggleLoader,
  enableBoxEdit,
  onReboot,
  onApplyUpdate,
  onFailoverInstall,
  getCarrier,
  getCurrentApn,
  setCarrier,
  numbers,
  updateAddress,
  clearAddress,
  addressModalData,
  updateBox,
  updateInterCalling,
  activateE2,
  deactivateE2,
  activateE3,
  deactivateE3,
  disableRecording,
  boxesSerial,
  enableRecording,
  user,
  addAction,
  disableAction,
  enableAction,
  addNote,
  changeAction,
  getEpikBoxesBySerialNumber,
  boxLock,
  eSIMStatus,
  eSIMStatusSwap,
  secondaryTunnel,
  secondaryTunnelStatus,
  getBoxesSerialNumber,
  eSIMStatusPing,
  getAddress,
  boxESimStatus,
  enableStarCodes,
  enableBoxCallForward,
  resetStarCodes,
  centerLatency,
  boxActiveSimStats,
  bandManagementStatus,
  OOBManagerHandler,
  removeOob,
  updateOOBDetail,
  oobLoadingHandler,
  oobLoading,
  assignedNumbers,
  ext_9override,
  updateDbcaAlert,
}) => {
  const [carrierType, setCarrierType] = useState(APNItems[1]);
  const [simType, setSimType] = useState(SIMItems[0]);
  const [dc, setDc] = useState(datacenters.find(dc => dc.value == box?.datacenter));
  const [simActiveLoading, setSimActiveLoading] = useState(false);
  const [voiceIndicator, setVoiceIndicator] = useState(false);
  // const [interfacePriority, setInterfacePriorityState] = useState(null);
  const [enableInhouseToggler, setEnableInhouseToggler] = useState(false);
  const [enablePortForwardToggler, setEnablePortForwardToggler] = useState(false);
  const [APNString, setAPNString] = useState('');
  const [APNCurrentString, setAPNCurrentString] = useState('');
  const [e2Strings, setE2Strings] = useState(
    box?.e2 || {
      enabled: false,
      IP: '',
      subnet: '',
      gateway: '',
    },
  );
  const [isModelGen4, setIsModelGen4] = useState(box?.model?.startsWith("G4"));

  const [isUpdateBtnDisable, setIsUpdateBtnDisable] = useState(false);
  const [currentModalData, setCurrentModalData] = useState({});
  const [passwordModalStatus, setPasswordModalStatus] = useState(false);
  const [enableE2Btn, setEnableE2Btn] = useState(true);
  const [priStatus] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipOpenPower, setTooltipOpenPower] = useState(false);
  const [tooltipOpenSave, setTooltipOpenSave] = useState(false);
  const [tooltipOpenSuspend, setTooltipOpenSuspend] = useState(false);

  const [tooltipOpenM, setTooltipOpenM] = useState(false);
  const [eSIMStatusValue, setESIMStatusValue] = useState('');
  const [simHistory, setSimHistory] = useState('');
  const [recordingTooltipOpen, setRecordingTooltipOpen] = useState(false);
  const [failoverStatus, setFailoverStatus] = useState(false);
  const [showQueryLrnModal, setShowQueryLrnModal] = useState(false);
  const [selectedNumberId, setSelectedNumberId] = useState();
  const [warningStatus, setWarningStatus] = useState(false);
  const [suspendModal, setSuspendModal] = useState(false);
  const [isCallRecorderLoading, setIsCallRecorderLoading] = useState(false);
  const [recordingModal, setRecordingModal] = useState(false);
  const [note, setSuspensionNote] = useState('');
  const [secTunnel, setSecTunnel] = useState(false);
  const [portLoading, setPortLoading] = useState(false);
  const [portAlerts, setPortAlerts] = useState(null);
  const [offlineProv, setOfflineProv] = useState(null);
  const [boxOptions, setBoxOptions] = useState({
    ...box,
    monitor: box?.monitor,
    recording: box?.recording,
    inhouseProvision: box?.inhouseProvision || false,
    e911Number: box?.e911Number || null,
    e2: e2Strings,
    e3: box?.e3 || false,
    expansionBox: box?.expansionBox || '',
    starCode: box?.starCodes || false,
  });
  const [interDialing, setInterDialing] = useState(box?.internationalDialing || false);
  const [enableExpansionBox, setEnableExpansionBox] = useState(!!box?.expansionBox);
  const [enableOfflineBoxCallForward, setEnableOfflineBoxCallForward] = useState(box?.boxOfflineCallForward);
  const [boxOfflineCallForwardNumber, setBoxOfflineCallForwardNumber] = useState(box?.boxOfflineCallForwardNumber);

  const [enableEnhanceRouting, setEnableEnhanceRouting] = useState(box?.advancedRouting);
  const [simOpenTooltip, setSimOpenTooltip] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isExpandingBox, setIsExpandingBox] = useState(false);
  const [simToggleLoading, setSimToggleLoading] = useState(false);
  const [numberConfirmation, setNumberConfirmation] = useState(false);
  const [reloadSimStatus, setReloadSimStatus] = useState(false);
  const [starToggleLoading, setStarToggleLoading] = useState(false);
  const [starResetLoading, setStarResetLoading] = useState(false);
  const [centerLatencyState, setcenterLatencyState] = useState({});
  const [customApnNameSelection, setCustomApnNameSelection] = useState(false);
  const [tooltipOpenSoft, setTooltipOpenSoft] = useState(false);
  const [tooltipOpenUpdate, setTooltipOpenUpdate] = useState(false);
  const [apnNameOptions, setApnNameOptions] = useState([]);
  const [activeCarrier, setactiveCarrier] = useState(null);
  const [newActiveCarrier, setNewActiveCarrier] = useState('');
  const [newActiveCarrierAPN, setNewActiveCarrierAPN] = useState('');
  const [loadingText, setLoadingText] = useState('');
  const [remoteCallOverflowToggle, setRemoteCallOverflowToggle] = useState(false); // Initialize the toggle as false
  const [phoneNumber, setPhoneNumber] = useState(''); // State to store the entered phone number

  const [extLoading, setExtLoading] = useState(false);
  const [extValue, setExtValue] = useState(box?.ext_9override ?? false);
  const [isE911Verified, setIsE911Verified] = useState(false);
  const [hideE911Loader, setHideE911Loader] = useState(false);
  const [customApn, setCustomApn] = useState(false);


  const priSettings = useSelector(state => state.AppState.priSipData?.priSettingData);
  const sipSettings = useSelector(state => state.AppState.priSipData?.sipSettingData);

  const dispatch = useDispatch();
  const fetchDataCenterLatency_ = async (
    boxId,
    type = DATA_LATENCY_TYPE.GET_LATENCY,
    ignoreInfoFlag = false,
  ) => dispatch(BoxesActions.fetchDataCenterLatency(boxId, true, undefined, type, ignoreInfoFlag));
  const resetDataCenterLatency_ = async () => dispatch(BoxesActions.resetDataCenterLatency());

  const dataCenterState = useSelector(state => state.AppState.boxDetails.dataCenterLatency);
  const { loading: dcLoading } = dataCenterState;
  const [dcOptionsWithLatency, setDcOptionsWithLatency] = useState(datacenters);
  const [dataCenterLatency, setDataCenterLatency] = useState({});
  const [dcUpdatePopup, setDcUpdatePopup] = useState({ show: false, value: {} });
  const [showIcon, setShowIcon] = useState(box?.OBEnable);
  const [dbcaAlert, setDbcaAlert] = useState(box?.dbcaAlerts || false);

  const interfacePriority = useSelector(state => state.UIState.epikBoxes.interfacePriority);
  const setInterfacePriorityState_ = data => dispatch(BoxesActions.setInterfacePriorityState(data));

  const [oobmTogglerValue, setOobmTogglerValue] = useState(showIcon || box?.OBEnable);
  const obisList = () => {
    const obisList = box?.Obis?.map(obis => {
      return [obis?.port1, obis?.port2];
    });
    const flatArray = obisList?.flat();
    const isVoice = flatArray?.some(obis => {
      return obis?.assignedNumberRef?.type === 'voice';
    });
    setVoiceIndicator(isVoice);
  };

  useEffect(() => {
    obisList();
    fetchDataCenterLatency_(box?._id, DATA_LATENCY_TYPE.GET_LATENCY, IGNORE_INFO_TOASTER);
    setcenterLatencyState(dataCenterState);
    return () => {
      resetDataCenterLatency_();
    };
  }, []);

  useEffect(() => {
    setDataCenterLatency({
      la: dataCenterState?.data?.laPingAvg,
      ch: dataCenterState?.data?.chPingAvg,
      ny: dataCenterState?.data?.nyPingAvg,
    });

    const state_ = dcOptionsWithLatency.map(val => {
      // Find the corresponding datacenter object based on value
    const matchingDatacenter = datacenters.find(dc => dc.value === val.value);

      console.log("val::",val)
      let temp = `${val.value}PingAvg`;
      return {
        ...val,
        label: matchingDatacenter.label + `${dataCenterState?.data[temp] ? `- ${dataCenterState?.data[temp]}ms` : ''} `,
      };
    });
    console.log('state_ dcCenter::', state_);
    setDcOptionsWithLatency(state_);
    setcenterLatencyState(dataCenterState);
  }, [dataCenterState]);

  const [spinnerMsg, setSpinnerMsg] = useState('Please wait, this could take up to 20 seconds');
  const initialRender = useRef(true);
  let defaultInterfacePriorite = null;
  const token = localStorage.getItem('jwtToken') || null;
  const isNumberKey = evt => {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  };

  useEffect(() => {
    if (e2Strings.IP.length > 0 && e2Strings.subnet.length > 0 && e2Strings.gateway.length > 0) {
      setEnableE2Btn(false);
    } else {
      setEnableE2Btn(true);
    }
    setBoxOptions({ ...boxOptions, e2: e2Strings });
  }, [e2Strings]);

  const one2InputChange = name => {
    const lastLetter = name.target.value.charAt(name.target.value.length - 1);
    const numberCheck = !isNaN(lastLetter);
    if (numberCheck || lastLetter === '.') {
      setE2Strings({ ...e2Strings, [name.target.name]: name.target.value });
    } else {
      toast.error('Please enter number or dot');
    }
  };

  const onCallRecordingToggle = async () => {
    setIsExpandingBox(true);
    setIsCallRecorderLoading(true);
    let isTrue = false;
    if (boxOptions.recording) {
      isTrue = await disableRecording(token, box?._id);
      if (isTrue) {
        // [Action]- Disable
        disableAction(
          `Call recording change from ${boxOptions.recording ? 'enabled' : 'disabled'} to ${boxOptions.recording ? 'disabled' : 'enabled'
          } `,
        );
      }
    } else {
      setRecordingModal(true);
      isTrue = await enableRecording(token, box?._id);

      if (isTrue) {
        // [Action] - Enable
        enableAction(
          `Call recording change from ${boxOptions.recording ? 'enabled' : 'disabled'} to ${boxOptions.recording ? ' disabled ' : 'enabled'
          }  `,
        );
      }
    }
    if (isTrue) {
      setBoxOptions({ ...boxOptions, recording: !boxOptions.recording });
      await updateBox(token, { ...box, recording: !boxOptions.recording });
    }
    setIsCallRecorderLoading(false);
    setIsExpandingBox(false);
  };

  const toggleRecordingTooltip = () => {
    setRecordingTooltipOpen(!recordingTooltipOpen);
  };

  const geteSIMStatus = async () => {
    setIsExpandingBox(true);
    setSimToggleLoading(true);
    setReloadSimStatus(true);
    await eSIMStatus(token, box?._id);
    setReloadSimStatus(false);
    setESIMStatusValue(boxESimStatus);
    // eslint-disable-next-line no-unused-expressions
    boxESimStatus ? setSimType(SIMItems[1]) : setSimType(SIMItems[0]);
    setSpinnerMsg('Please wait, this could take up to 20 seconds');
    setIsExpandingBox(false);
  };

  useMemo(() => {
    // eslint-disable-next-line no-console
    if (typeof boxESimStatus === 'boolean') {
      eSIMStatusPing(boxESimStatus);
      if (boxESimStatus === simHistory) {
        setReloadSimStatus(false);
        setESIMStatusValue(boxESimStatus);
        setSimHistory(boxESimStatus);
        toast.info(
          // eslint-disable-next-line max-len
          'SIM swap request sent. This process can take several minutes to take effect. Please refresh in 3 minutes.',
        );
      } else {
        setSimToggleLoading(false);
        setReloadSimStatus(true);
        setESIMStatusValue(boxESimStatus);
        setSimHistory(boxESimStatus);
      }
      boxESimStatus ? setSimType(SIMItems[1]) : setSimType(SIMItems[0]);
    } else {
      setReloadSimStatus(false);
      eSIMStatusPing(null);
      boxESimStatus ? setSimType(SIMItems[1]) : setSimType(SIMItems[0]);
    }
    setSpinnerMsg('Please wait, this could take up to 20 seconds');
  }, [boxESimStatus]);

  const onReloadStatus = () => {
    setReloadSimStatus(true);
    geteSIMStatus();
  };

  const handleActiveSim = async () => {
    setSimActiveLoading(true);
    const simStatus = simType.value !== 'BackUp';
    const { data, checks } = await eSIMStatusSwap(token, simStatus, box?._id);
    if (checks) {
      changeAction(
        `eSIM changed from  ${simStatus ? 'Primary' : ' BackUp'} to ${simStatus ? ' BackUp' : 'Primary'
        }`,
      );
    }
    // eslint-disable-next-line no-unused-expressions
    await utils.delay(20000);
    setSpinnerMsg('Please wait, Sim status is updating.');
    await geteSIMStatus();
    if (data?.description) toast.info(data.description);
    setSimActiveLoading(false);
  };
  const handleESIMSwapStatus = async e => {
    setSimType(e);
  };

  const getWireguardValue = (wgString) => {
    if (wgString?.includes('Enabled')) return true;

    const regex = /:(\s*\d+)/; // Regular expression to match colon followed by digits
    const match = wgString?.match(regex);
    if (match && match[1]) {
      const numberAfterColon = parseInt(match[1].trim(), 10);
      return numberAfterColon === 1;
    }

    return false;
  }

  const getSecondaryStatus = async () => {
    const secondaryStatus = await secondaryTunnelStatus(token, box?._id);
    const wgVal = getWireguardValue(secondaryStatus?.Response);
    setSecTunnel(wgVal);
  };

  const getBoxActiveSimStats = async (token, boxId) => {
    const simStats = await boxActiveSimStats(token, boxId);

    const apnOptions = simStats?.apnArr?.reduce((filteredOpt, currOpt) => {
      const opt = {
        label: currOpt,
        value: currOpt,
      };
      filteredOpt.push(opt);
      return filteredOpt;
    }, []);

    if (!apnOptions) return;
    setApnNameOptions(apnOptions);
    setactiveCarrier(simStats?.activeCarrier);
  };

  const v3Hits = async () => {
    if (!box?.myEpik) {
      await getPriority();
      await getAPN(APNItems[1].value);
      await getCurrentCarrier();
      await setCarrierType(APNItems[1]);
      // geteSIMStatus();
      await getSecondaryStatus();
      await getBoxActiveSimStats(token, box?._id);
    }
  };

  const calculateTimeDifference = () => {
    const newData = new Date();
    const lastClickDate = new Date(box?.epiLastFlip);
    const mintDifference = newData?.getTime() - lastClickDate?.getTime();

    return mintDifference / 60000;
  };

  useEffect(() => {
    v3Hits();
    setPortAlerts(boxOptions?.portAlerts);
    setOfflineProv(boxOptions?.offlineProvision);
    getBoxesSerialNumber(token, box?.assignedTo?._id, true);
  }, []);

  const handleSave = () => {
    const data = { ...boxOptions, ...box };
    data.removedSlaves = [];
    const CheckMonitorToggle = true;
    onConfirm(data, CheckMonitorToggle);
  };

  useEffect(() => {
    if (!initialRender.current) handleSave();
    else initialRender.current = false;
  }, [boxOptions.monitor, boxOptions.e3]);

  const saveOptions = () => {
    handleSave();
    if (!priStatus) {
      priStatusCheck(priStatus);
    }
  };

  const handleUpdateBtnFunc = () => {
    setIsUpdateBtnDisable(true);
  };

  const toggleMonitoring = async () => {
    await updateBox(token, { ...box, monitor: !box?.monitor });
    addAction(
      `Monitoring change from ${box?.monitor ? 'enabled' : 'disabled'} to ${box?.monitor ? ' disabled ' : 'enabled'
      }  `,
    );
  };

  const toggleAdvanceMonitoring = () => {
    if (advMonitoring) {
      advancedMonitoring(!advMonitoring);
      editOptionsChange('advancedMonitoring', !advMonitoring);
    } else if (box?.vpnAddress) {
      advancedMonitoring(!advMonitoring);
      editOptionsChange('advancedMonitoring', !advMonitoring);
    } else {
      toast.error(
        'You can`t enable Advance monitoring because there`s no VPN address listed for this box?.',
      );
    }
  };
  const openPasswordModal = () => {
    setWarningStatus(false);
    setPasswordModalStatus(true);
  };
  const onSecondaryTunnel = async () => {
    if (enableBoxEdit) {
      setSecTunnel(false);
      const secondaryStatusValue = await secondaryTunnel(token, box?._id, secTunnel);
      const wgVal = getWireguardValue(secondaryStatusValue?.result?.Response);
      setSecTunnel(wgVal);
      if (secondaryStatusValue?.checks) {
        // add action
        changeAction(
          `Secondary Tunnel changed from ${secTunnel ? 'enabled' : 'disabled'} to ${secTunnel ? 'disabled' : 'enabled'
          }`,
        );
      }
    } else {
      console.log('not permitted');
    }
  };

  const onPassSecurityModal = async () => {
    setPasswordModalStatus(false);
    if (currentModalData.type === 'monitoring') {
      toggleMonitoring();
    } else if (currentModalData.type === 'secondary') {
      onSecondaryTunnel();
    } else if (currentModalData.type === 'advancedMonitoring') {
      toggleAdvanceMonitoring();
    } else if (currentModalData.type === 'dcAutoUpdate') {
      handleDcAutoUpdateToggle();
    } else if (currentModalData.type === 'internationalDialing') {
      handleInternationalDialingToggle();
    } else if (currentModalData.type === BAND_MANAGEMENT) {
      setCurrentModalData({});
      bandToggleHandler(oobmTogglerValue);
    } else if (currentModalData.type === omitLeading9) {
      setCurrentModalData({});
      ext9OverrideToggleHandler(!extValue)
    } else if (currentModalData.type === DATA_CENTER) {
      setIsExpandingBox(true);
      setWarningStatus(false);

      const draftDc = { ...dc };
      const { value } = draftDc;
      setIsLoading(true);
      const res = await updateBox(token, {
        ...box,
        datacenter: value,
      });

      setLoadingText(`Device Registration Move In Progress… \n Please Wait. This page will refresh in 60 seconds.`)
      const timerId = setTimeout(() => {
        changeAction('datacenter changed');
        window.location.reload();
      }, 60000);
      if (!res) {
        clearTimeout(timerId);
        setIsLoading(false);
        setIsExpandingBox(false);
      }
    }
  };

  const getAPN = async carrier => {
    const res = await getCarrier(token, box?.vpnAddress, carrier);
    if (res) {
      setAPNString(res.apn);
    }
  };

  const getCurrentCarrier = async () => {
    const res = await getCurrentApn(token, box?.vpnAddress);
    if (res) {
      setAPNCurrentString(res.apn);
      setAPNString(res.apn);
    }
  };

  const getPriority = async () => {
    const res = await getInterfacePriority(token, box?.vpnAddress);
    if (res) {
      defaultInterfacePriorite = res;
      setInterfacePriorityState_(res);
    } else {
      setInterfacePriorityState_(null);
    }
  };

  const handleInterfacePriority = async () => {
    const priorityOfInterest = [...interfacePriority].join(',');
    const res = await setInterfacePriority(token, box?.vpnAddress, priorityOfInterest);
    if (res) {
      getPriority();
      // [Action]- Change
      changeAction(
        `Interface priority Changed from ${defaultInterfacePriorite} to ${priorityOfInterest}`,
      );
    }
  };

  const handleSetCarrier = async () => {
    const data = {
      carrier: newActiveCarrier,
      apn: newActiveCarrierAPN,
    };

    const res = await setCarrier(token, box?.vpnAddress, data);
    if (res) {
      getAPN(carrierType.value);
      getCurrentCarrier();
      // [Action]- Change
      changeAction('APN changed');
    }
  };

  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  const toggleTooltipPower = () => setTooltipOpenPower(!tooltipOpenPower);
  const toggleTooltipSave = () => setTooltipOpenSave(!tooltipOpenSave);
  const toggleTooltipSoft = () => setTooltipOpenSoft(!tooltipOpenSoft);
  const toggleTooltipUpdate = () => setTooltipOpenUpdate(!tooltipOpenUpdate);
  const toggleTooltipSuspend = () => setTooltipOpenSuspend(!tooltipOpenSuspend);

  const toggleSimTooltip = () => setSimOpenTooltip(!simOpenTooltip);
  const toggleTooltipM = () => setTooltipOpenM(!tooltipOpenM);

  const handleAPNChange = e => {
    const reg = /^[\.a-zA-Z0-9]*$/g;
    if (reg.test(e.target.value)) {
      setAPNString(e.target.value);
    }
  };

  const handlePortAlerts = async () => {
    setPortAlerts(null);
    setIsExpandingBox(true);
    const data = await updateBox(token, { ...box, portAlerts: !box?.portAlerts });
    if (data) {
      changeAction(
        ` portAlerts toggle change from  ${box?.portAlerts ? 'enabled' : 'disabled'} to ${box?.portAlerts ? 'disabled' : 'enabled'
        }`,
      );
    }
    setPortAlerts(data);
    setIsExpandingBox(false);
  };
  const handleOfflineProv = async () => {
    setIsExpandingBox(true);
    setOfflineProv(null);
    const data = await updateBox(token, {
      ...box,
      offlineProvision: !box?.offlineProvision,
    });
    if (data) {
      changeAction(
        ` offline Provisioning toggle change from  ${box?.offlineProvision ? 'enabled' : 'disabled'
        } to ${box?.offlineProvision ? 'disabled' : 'enabled'}`,
      );
    }
    setOfflineProv(data);
    setIsExpandingBox(false);
  };

  const move = (from, to, arr = interfacePriority) => {
    const clone = [...arr];
    Array.prototype.splice.call(clone, to, 0, Array.prototype.splice.call(clone, from, 1)[0]);
    setInterfacePriorityState_(clone);
  };

  const e911ModalHandler = (number, showModal, id) => {
    setBoxOptions({ ...boxOptions, e911Number: number });
    setShowQueryLrnModal(showModal);
    setSelectedNumberId(id);
    if (id) {
      setSelectedNumberId(id);
      getAddress(token, id);
    }
  };

  const onUpdate = async e => {
    optionsBoxChange({ boxOptions });
    let resApi = await updateAddress(token, selectedNumberId, e);
    if (resApi) setShowQueryLrnModal(false);
    const res = updateBox(token, { ...boxOptions });
    clearAddress();
    if (res) {
      changeAction(`E911 number updated from ${box?.e911Number || '-'} to ${e.dn}`);
    }
  };
  const onFailoverPress = () => {
    setFailoverStatus(true);
    onFailoverInstall();
  };

  const handleE2Save = async () => {
    const res = await activateE2(token, box?._id, e2Strings);
    if (res) {
      if (box?.e2.IP && !e2Strings.IP) {
        // [Action] - Add
        addAction('Static E1 IP Type added');
      } else {
        // [Action] - Change
        changeAction('Static E1 IP Type changed');
      }
    }
  };

  const onWarningConfirm = async () => {
    const result = await activateE3(token, box?._id);
    if (result) {
      await enableAction(`E2 toggle enabled`);
      setBoxOptions({ ...boxOptions, e3: !boxOptions.e3 });
    }
    setWarningStatus(false);
  };

  const onE3Toggle = async () => {
    if (boxOptions.e3) {
      const result = await deactivateE3(token, box?._id);
      if (result) {
        setBoxOptions({ ...boxOptions, e3: !boxOptions.e3 });
        //[Action] - disabled
        await disableAction(`E2 toggle disabled`);
      }
    } else {
      //[Action] - enabled
      setCurrentModalData(warningText);
      setWarningStatus(true);
    }
  };

  const handleCleare911Num = async () => {
    if (voiceIndicator) {
      toast.error('Please remove voice type ports before clearing E911 number');
      return;
    }
    setIsLoading(true);
    // [Action] - Change
    const res = await updateBox(token, { ...boxOptions, e911Number: '' });
    if (res) {
      changeAction(`Clear E911 number ${boxOptions.e911Number}`);
    }
    setIsLoading(false);
  };

  const handlePriSip = async () => {
    if (!box?.features?.showPriTab) {
      setIsExpandingBox(true);
      const features = {
        ...box?.features,
        showPriTab: !box?.features?.showPriTab,
      };
      await updateBox(token, { ...box, features });
      setIsExpandingBox(false);
    } else if (
      priSettings?.numberSettings?.numbers?.length > 0 ||
      sipSettings?.numberSettings?.numbers?.length > 0
    ) {
      toast.error('Please delete all numbers before disabling PRI');
    } else if (box?.features?.pri || box?.features?.sip) {
      toast.error('Please disable both SIP & PRI toggle before disabling SIP || PRI');
    } else {
      setIsExpandingBox(true);
      const features = {
        ...box?.features,
        showPriTab: !box?.features?.showPriTab,
      };
      await updateBox(token, { ...box, features });
      setIsExpandingBox(false);
    }
  };

  const handleDcAutoUpdateToggle = async () => {
    setIsExpandingBox(true);
    const features = {
      ...box?.features,
      dcAutoUpdate: !box?.features?.dcAutoUpdate,
    };
    try {
      await updateBox(token, { ...box, features });
    } catch (error) {
      toast.error('Error occured while setting the data center auto update flag');
    }
    setIsExpandingBox(false);
  };

  const handleInternationalDialingToggle = async () => {
    setIsExpandingBox(true);
    const result = await updateInterCalling(token, box?._id, { status: !interDialing });
    if (result) {
      setInterDialing(!interDialing);
    } else {
      toast.error('Error occured while setting the International Dialing.');
    }
    setIsExpandingBox(false);
  }

  const HandleInHousingToggle = async () => {
    setIsExpandingBox(true);
    if (calculateTimeDifference() > 5 || !box?.epiLastFlip) {
      setEnableInhouseToggler(true);
      setBoxOptions({ ...boxOptions, inhouseProvision: !boxOptions.inhouseProvision });
      const res = await updateBox(token, {
        ...box,
        inhouseProvision: !boxOptions.inhouseProvision,
      });
      if (res) {
        if (boxOptions.inhouseProvision) {
          //[Action] - Disable
          await disableAction('epik EPI provisioning disabled');
        } else {
          //[Action] - Enable
          await enableAction('epik EPI provisioning enabled');
        }
      }
      if (!res) {
        setBoxOptions({ ...boxOptions, inhouseProvision: box?.inhouseProvision });
      }
      setEnableInhouseToggler(false);
    } else {
      toast.info('Settings are being sent to EPI. Switch is disabled for 5 minutes');
    }
    setIsExpandingBox(false);
  };

  const handleExpansionBox = async () => {
    setIsExpandingBox(true);

    const { docs: boxes } = await getEpikBoxesBySerialNumber(token, boxOptions.expansionBox, false);
    const masterBox = boxes[0];
    const secondaryObis = box.Obis.map(item => item._id);
    await boxLock(token, masterBox._id);
    // update primary box
    const res = await updateBox(token, {
      ...masterBox,
      slaveBoxes: [box?._id],
      obis: [...masterBox.obis, ...secondaryObis],
      Obis: [...masterBox.obis, ...secondaryObis],
    });
    if (res) {
      // [Action]- Change
      changeAction(`add obis to master box ${secondaryObis?.toString()}`);
    }

    // update secondary box
    const response = await updateBox(token, {
      ...box,
      masterBox: masterBox._id,
      Obis: [],
      removedObis: secondaryObis,
      expansionBox: boxOptions.expansionBox,
    });
    setIsExpandingBox(false);
    if (response) {
      // [Action]- Change
      changeAction('remove obis from salve box');
    }
  };




  const handleBoxOfflineCallForwardNumber = async e => {
    setIsExpandingBox(true);
    let callForwardEnable = enableOfflineBoxCallForward
    let callForwardEnableNumber = boxOfflineCallForwardNumber
      setStarToggleLoading(true);
      const res = await enableBoxCallForward(token, box?._id, callForwardEnable, callForwardEnableNumber);
      if (res) {
        setBoxOptions({ ...boxOptions, starCodes: true });
        // [Action] - Enable
        enableAction('Star Codes enabled');
      }
      setStarToggleLoading(false);
   
    setIsExpandingBox(false);
  };

  const disableBoxOfflineCallForward = async () => {
    let callForwardEnable = false
    let callForwardEnableNumber = boxOfflineCallForwardNumber
    const res = await enableBoxCallForward(token, box?._id, callForwardEnable, callForwardEnableNumber);
    if (res) {
      setBoxOptions({ ...boxOptions, starCodes: true });
      // [Action] - Enable
      enableAction('Star Codes enabled');
    }
    setStarToggleLoading(false);
   
    setIsExpandingBox(false);
  };

  const disableExpansionBox = async () => {
    setIsExpandingBox(true);

    const { docs: boxes } = await getEpikBoxesBySerialNumber(token, boxOptions.expansionBox, false);
    const masterBox = boxes[0];

    await boxLock(token, masterBox._id);

    // remove duplicate obis
    const masterObis = masterBox.obis.filter(item => !boxOptions.removedObis.includes(item));

    // update primary box
    const res = await updateBox(token, {
      ...masterBox,
      slaveBoxes: [],
      obis: [...masterObis],
      Obis: [...masterObis],
    });

    if (res) {
      // [Action] - Change;
      changeAction('remove slave obis to master box');
    }

    // update secondary box
    const response = await updateBox(token, {
      ...box,
      masterBox: null,
      Obis: [...box.Obis, ...box?.removedObis],
      removedObis: [],
      expansionBox: '',
    });
    setIsExpandingBox(false);
    if (response) {
      // [Action]- Change
      changeAction('add removed obis to salve box');
    }
  };

  const removeValueFromArray = (array, value) => {
    const index = array.indexOf(value);
    if (index !== -1) {
      array.splice(index, 1);
    }
    return array;
  };

  const onHardReset = async () => {
    setCurrentModalData(warningHardReset);
    setWarningStatus(true);
  };

  const handleDeactivateE2 = async () => {
    if (e2Strings.enabled) {
      const res = await deactivateE2(token, box?._id);
      if (res) {
        if (e2Strings.enabled) {
          // [Action]-Disable
          disableAction('E1 IP Type change from enable to disable');
        } else {
          // [Action] - Enable
          enableAction('E1 IP Type change from disabled to enabled');
        }
      }
    }
    setE2Strings({ ...e2Strings, enabled: !e2Strings.enabled });
  };

  const onStarCodeToggle = async e => {
    setIsExpandingBox(true);
    if (!boxOptions.starCodes) {
      setStarToggleLoading(true);
      const res = await enableStarCodes(token, box?._id);
      if (res) {
        setBoxOptions({ ...boxOptions, starCodes: true });
        // [Action] - Enable
        enableAction('Star Codes enabled');
      }
      setStarToggleLoading(false);
    }
    setIsExpandingBox(false);
  };
  const handleStarReset = async () => {
    setStarResetLoading(true);
    const res = await resetStarCodes(token, box?._id);
    if (res) {
      // [Action] - Disable
      disableAction('Star Codes reset');
    }
    setStarResetLoading(false);
  };

  const onDataCenterSelection = value => {
    const sourceLatency = dataCenterLatency[dc.value];
    const targetLatency = dataCenterLatency[value.value];

    setDc(value);

    if (!sourceLatency && !targetLatency) {
      toast.error('Failed to fetch latency of data centers');
    }
  };

  const updateDCNames = (existingDC, updatedDC) => {
    let existingDCName;
    let updatedDCName;
    switch (existingDC) {
      case 'la':
        existingDCName = 'Los Angeles';
        break;
      case 'ny':
        existingDCName = 'New York';
        break;
      case 'at':
        existingDCName = 'Atlanta';
        break;
      default:
        existingDCName = 'Chicago';
        break;
    }
    switch (updatedDC) {
      case 'la':
        updatedDCName = 'Los Angeles';
        break;
      case 'ny':
        updatedDCName = 'New York';
        break;
      case 'at':
        updatedDCName = 'Atlanta';
        break;
      default:
        updatedDCName = 'Chicago';
        break;
    }
    return { existingDCName, updatedDCName };
  };

  const onCommit = () => {
    const { existingDCName, updatedDCName } = updateDCNames(box?.datacenter, dc.value);

    datacenterWarningText.subHeader = `Move Device Registration from ${existingDCName} to ${updatedDCName}?`;

    const selectedDC = dc.value;
    if (parseFloat(dataCenterLatency[selectedDC]) > parseFloat(dataCenterLatency[box?.datacenter])) {
      setDcUpdatePopup({ show: true, dc });
    } else {
      setCurrentModalData(datacenterWarningText);
      setWarningStatus(true);
    }
  };

  const onUpdateDC = async () => {
    const boxId = box?._id;

    /* API CALLS => UPDATE LATENCY CALL FOLLOWED BY GET LATENCY CALL AFTER 60 seconds */
    await fetchDataCenterLatency_(boxId, DATA_LATENCY_TYPE.UPDATE_LATENCY);
    await utils.sleep(SIXTY_SECONDS_DELAY);
    await fetchDataCenterLatency_(boxId, DATA_LATENCY_TYPE.GET_LATENCY, IGNORE_INFO_TOASTER);
  };

  const onEnhanceRouting = async e => {
    const { checked } = e.target;
    setEnableEnhanceRouting(!enableEnhanceRouting);
  };

  const [showWarningModel, setShowWarningModel] = useState(false);

  const warningCancelHandler = () => {
    setShowWarningModel(false);
    setIsLoading(false);
  };

  const warningGoHandler = () => {
    oobLoadingHandler(true);
    OOBManagerHandler(true);
  };

  useEffect(() => {
    if (box?.internationalDialing !== interDialing) {
      setInterDialing(box?.internationalDialing);
    }

    if (box.OBEnable !== showIcon) {
      setShowIcon(box.OBEnable);
    }
    setShowWarningModel(false);
  }, [box]);

  const bandToggleHandler = toggleValue => {
    if (toggleValue) {
      setShowWarningModel(true);
    } else {
      user.role === 'superAdmin' && removeOOBService();
      oobLoadingHandler(true);
    }
  };

  const removeOOBService = async () => {
    const res = await removeOob(token, box._id);
    if (res) {
      setShowIcon(false);
      updateOOBDetail();
    }
    oobLoadingHandler(false);
  };
  const ext9OverrideToggleHandler = async (extValue) => {
    setExtLoading(true)
    const res = await ext_9override(token, box.vpnAddress, extValue);
    if (res) {
      setExtValue(extValue)
    }
    setExtLoading(false)
  }

  const getPinCodeName = () => {
    let featureName = ''

    switch (currentModalData.type) {
      case 'enhancedFax':
        featureName = PIN_CODES_NAME.faxCode;
        break;
      case DATA_CENTER:
        featureName = PIN_CODES_NAME.datacenterCode;
        break;
      case 'dcAutoUpdate':
        featureName = PIN_CODES_NAME.dcAutoUpdate;
        break;
      case 'internationalDialing':
        featureName = PIN_CODES_NAME.internationalDialing;
        break;
      case BAND_MANAGEMENT:
        featureName = PIN_CODES_NAME.bandManagement;
        break;
      case omitLeading9:
        featureName = PIN_CODES_NAME.omitLeading9;
        break;
      default:
        featureName = currentModalData.type
    }

    return featureName;
  }

  useEffect(() => {
    if (box?.e911Number) {
      const suggestions = assignedNumbers?.filter(did => did.number === box?.e911Number)

      e911ModalHandler(box?.e911Number, false, suggestions[0]?._id);
    }
  }, [])

  useEffect(() => {
    if (box?.e911Number && addressModalData?.address1) {
      setIsE911Verified(true);
    } else {
      setHideE911Loader(true)
    }
  }, [addressModalData])

  const onDbcaAlertToggle = async() => {
    console.log('here... ', dbcaAlert);
    const res = await updateDbcaAlert(token, box._id, !dbcaAlert);
    if (res)
      setDbcaAlert(!dbcaAlert);
  }

  const checkThirdOctet = parseInt(box?.vpnAddress?.split('.')[2], 10) >= 20;
  return (
    <div className="optionsContainer">
      {isExpandingBox && <Spinner customText={loadingText} />}
      {user.readOnly ? (
        <div className="error-msg text-center">Unauthorized: Role is readonly.</div>
      ) : (
        <>
          {showQueryLrnModal && (
            <E911AddressModal
              selectedNumberTitle={boxOptions.e911Number}
              data={addressModalData}
              onUpdate={onUpdate}
              isOpen={showQueryLrnModal}
              onCancel={() => (setShowQueryLrnModal(false), clearAddress())}
            />
          )}
          <div className="row data-container">
            <div className="box-type-container col-md-10">
              {!box?.myEpik && (
                <Row>
                  <Col
                    sm={3}
                    id="test-e911-number"
                    style={{ marginTop: '10px' }}
                    className="type-header"
                  >
                    E911 Number:
                  </Col>
                  <Col sm={isE911Verified ? 4 : 5}>
                    {assignedNumbers && assignedNumbers.length > 0 && (
                      <>
                        <BoxAutocomplete
                          placeholder="Filter Numbers"
                          searchTerm={box?.e911Number}
                          numbers={assignedNumbers}
                          onChange={e => {
                            if (e.suggestion) {
                              e911ModalHandler(e.value, true, e.suggestion._id);
                            }
                          }}
                        />
                      </>
                    )}
                  </Col>
                  {box?.e911Number && (
                    <Col style={{ padding: "5px" }} sm={isE911Verified ? 3 : 0}>
                      {assignedNumbers && assignedNumbers.length > 0 && isE911Verified ? (
                        <>
                          <span style={{ color: "#28a745" }}>
                            <FontAwesomeIcon
                              icon="check-circle"
                              size="lg"
                              color="#28a745"
                              style={{ marginRight: '0.5rem' }}
                            />
                            Address Verified
                          </span>
                        </>
                      ) : !hideE911Loader ? (<SpinnerCircles red />) : ''}
                    </Col>
                  )}
                  <Col sm={2}>
                    {isLoading ? (
                      <SpinnerCircles red />
                    ) : (
                      box?.e911Number && (
                        <Button color="primary" onClick={handleCleare911Num}>
                          Clear
                        </Button>
                      )
                    )}
                  </Col>
                </Row>
              )}
            </div>

            {
              // Omit Leading 9
              <div className="box-type-container col-md-10">
                <Row>
                  <Col sm={5} id="test-enable-sip-pri-label" className="type-header d-flex">
                    Omit Leading 9:
                    <sup>
                      <InfoPopup id="leading9" text={TOOLTIPS_TEXT.LEADING9} />
                    </sup>
                  </Col>
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    {extLoading ? (
                      <SpinnerCircles red />
                    ) : (
                      <Toggle
                        id="ext-switch-toggle"
                        disabled={extLoading}
                        value={extValue}
                        onToggle={async toggleValue => {
                          console.log('typeof toggle ', toggleValue)
                          setCurrentModalData({ type: omitLeading9 });
                          setPasswordModalStatus(true);
                          // ext9OverrideToggleHandler(!toggleValue)
                        }}
                      />
                    )}
                  </Col>
                </Row>
              </div>
            }

            {
              // bandManagementStatus &&
              <div className="box-type-container col-md-10">
                <Row>
                  <Col sm={5} id="test-enable-sip-pri-label" className="type-header d-flex">
                    Enable Out of Band Management:
                    <sup>
                      <InfoPopup id="oobm" text={TOOLTIPS_TEXT.Band_MANAGEMENT} />
                    </sup>
                  </Col>
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    {oobLoading ? (
                      <SpinnerCircles red />
                    ) : (
                      <Toggle
                        id="oobm-switch-toggle"
                        disabled={oobLoading}
                        value={showIcon}
                        onToggle={async toggleValue => {
                          setOobmTogglerValue(!toggleValue);
                          setCurrentModalData({ type: BAND_MANAGEMENT });
                          setPasswordModalStatus(true);
                        }}
                      />
                    )}
                  </Col>
                </Row>
              </div>
            }

            <div className="box-type-container col-md-10">
              <Row className="align-items-center">
                <Col sm={5} id="test-enable-expansion-box" className="type-header d-flex">
                  Enable Expansion Module
                  <sup>
                    <InfoPopup id="enable-exp-module" text={TOOLTIPS_TEXT.ENABLE_EXP_MODULE} />
                  </sup>
                </Col>

                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    value={enableExpansionBox}
                    id="test-enable-expansion-box-toggle"
                    onToggle={e => {
                      setIsExpandingBox(true);
                      setEnableExpansionBox(!enableExpansionBox);
                      if (e && !!box?.expansionBox) {
                        disableExpansionBox();
                      }
                      setIsExpandingBox(false);
                    }}
                  />
                </Col>

                {enableExpansionBox && (
                  <>
                    <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <DynamicAutoComplete
                        isDisabled={!!box?.expansionBox}
                        searchTerm={boxOptions.expansionBox}
                        dropdownList={removeValueFromArray(boxesSerial, box?.serialNumber)}
                        onChange={({ suggestion }) => {
                          setBoxOptions(prev => ({ ...prev, expansionBox: suggestion }));
                        }}
                        placeholder="Serial Number"
                      />
                    </Col>
                    {!box?.expansionBox ? (
                      <Col md={2}>
                        <Button
                          color="primary"
                          onClick={() => handleExpansionBox()}
                          id="test-dynamic-autocomplete-save-btn"
                        >
                          Save
                        </Button>
                      </Col>
                    ) : null}
                  </>
                )}
              </Row>
            </div>
            {box.boxRegistrar === 'Unified' && (
              <div className="box-type-container col-md-10">
                <EnhancedRouting />
              </div>
            )}
            {!box.advancedRouting && (
              <div className="box-type-container col-md-10">
                <BoxRegistrar />
              </div>
            )}
            <div className="box-type-container col-md-10">
              <Row className="align-items-center">
                <Col sm={5} id="test-enable-enhanced-fax" className="type-header d-flex">
                  Enable Enhanced Fax
                </Col>

                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    value={!!box?.enhancedFax}
                    id="test-enable-enhanced-fax-toggle"
                    onToggle={() => {
                      if (!box?.enhancedFax) {
                        setCurrentModalData(warningEnhancedFax);
                        setWarningStatus(true);
                      } else {
                        setCurrentModalData(warningDisableEnhancedFax);
                        setWarningStatus(true);
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
            {/* <div className="box-type-container col-md-10">
              <Row>
                <Col id="pricing-toggle" sm={4} className="type-header d-flex">
                  Advance monitoring:
                  <sup>
                    <InfoPopup id="advance-monitoring" text={TOOLTIPS_TEXT.ADV_MONITORING} />
                  </sup>
                </Col>
                <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  {!enableToggleLoader ? (
                    <Toggle
                      value={advMonitoring}
                      id="test-advance-monitoring-toggle"
                      onToggle={() => {
                        setIsExpandingBox(true);
                        if (enableBoxEdit) {
                          setCurrentModalData(warningAdvancedMonitoringTxt);
                          setWarningStatus(true);
                        } else {
                          console.log('not permitted');
                        }
                      }}
                    />
                  ) : (
                    <div>
                      <SpinnerCircles red />
                    </div>
                  )}
                </Col>
              </Row>
            </div> */}
            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="pricing-toggle-M" className="type-header d-flex">
                  Port Alerts:
                  <sup>
                    <InfoPopup id="port-alerts" text={TOOLTIPS_TEXT.PORT_ALERT} />
                  </sup>
                </Col>
                {portAlerts === null ? (
                  <div>
                    <SpinnerCircles red />
                  </div>
                ) : (
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      id="test-port-alerts-toggle"
                      value={box?.portAlerts}
                      onToggle={handlePortAlerts}
                    />
                  </Col>
                )}
              </Row>
            </div>
            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="pricing-toggle-M" className="type-header d-flex">
                  Offline Provisioning:
                  <sup>
                    <InfoPopup id="offline-prov" text={TOOLTIPS_TEXT.OFFLINE_PROV} />
                  </sup>
                </Col>
                {offlineProv === null ? (
                  <div>
                    <SpinnerCircles red />
                  </div>
                ) : (
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      id="test-offline-provisioning-toggle"
                      value={box?.offlineProvision}
                      onToggle={handleOfflineProv}
                    />
                  </Col>
                )}
              </Row>
            </div>
            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="pricing-toggle-M" className="type-header d-flex">
                  Monitoring:
                  <sup>
                    <InfoPopup id="monitoring" text={TOOLTIPS_TEXT.MONITORING} />
                  </sup>
                </Col>
                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    value={box?.monitor}
                    id="test-price-toggle-M"
                    onToggle={() => {
                      // setIsExpandingBox(true);
                      if (enableBoxEdit) {
                        setCurrentModalData(warningMonitoringTxt);
                        setWarningStatus(true);
                      } else {
                        console.log('not permitted');
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>

            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="dbca_alert" className="type-header d-flex">
                  DBCA Alert:
                  <sup>
                    <InfoPopup id="dbca" text={TOOLTIPS_TEXT.DBCA_ALERT} />
                  </sup>
                </Col>
                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    value={dbcaAlert}
                    id="test-dbca-alert"
                    onToggle={onDbcaAlertToggle}
                  />
                </Col>
              </Row>
            </div>

            {!box?.myEpik ? (
              <>
                <div className="box-type-container col-md-10">
                  <Row>
                    <Col sm={5} id="test-secondary-tunnel" className="type-header d-flex">
                      Secondary Tunnel:
                      <sup>
                        <InfoPopup id="secondary-tunnel" text={TOOLTIPS_TEXT.SECONDARY_TUNNEL} />
                      </sup>
                    </Col>
                    <Col
                      sm={2}
                      style={{
                        display: 'flex',
                        verticalAlign: 'middle',
                      }}
                    >
                      {secTunnel === null ? (
                        <div>
                          <SpinnerCircles red />
                        </div>
                      ) : (
                        <Toggle
                          id="test-secondary-tunnel-toggle"
                          value={secTunnel}
                          onToggle={() => {
                            // setIsExpandingBox(true);
                            openPasswordModal();
                            setCurrentModalData(secondarySwitch);
                          }}
                        />
                      )}
                    </Col>
                  </Row>
                </div>
                <div className="box-type-container col-md-10">
                <Row className="align-items-center">
                <Col sm={enableOfflineBoxCallForward ? 4 : 8} id="test-enable-expansion-box" className="type-header d-flex">
                Remote Call Overflow:
                  <sup>
                    <InfoPopup id="enable-exp-module" text={TOOLTIPS_TEXT.BOX_OFFLINE_CALL_FORWARD} />
                  </sup>
                </Col>
                {enableOfflineBoxCallForward && (
                  <>
                    <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Input
                          id="active-carrier-input"
                          type="text"
                          value={boxOfflineCallForwardNumber}
                          onChange={(e) => setBoxOfflineCallForwardNumber(e.target.value)} // Update the state when the input changes

                        />
                    </Col>
                    {!box?.expansionBox ? (
                      <Col md={2}>
                        <Button
                          color="primary"
                          onClick={() => handleBoxOfflineCallForwardNumber()}
                          id="test-dynamic-autocomplete-save-btn"
                        >
                          Save
                        </Button>
                      </Col>
                    ) : null}
                  </>
                )}
                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    value={enableOfflineBoxCallForward}
                    id="test-enable-expansion-box-toggle"
                    onToggle={e => {
                      setIsExpandingBox(true);
                      setEnableOfflineBoxCallForward(!enableOfflineBoxCallForward);
                      if (e && !!box?.boxOfflineCallForward) {
                        setEnableOfflineBoxCallForward(false);

                        disableBoxOfflineCallForward();
                      }
                      setIsExpandingBox(false);
                    }}
                  />
                </Col>

                
              </Row>
          
                </div>
                <div className="box-type-container col-md-10">
                  <Row>
                    <Col sm={5} id="test-start-code" className="type-header d-flex">
                      Star Codes:
                      <sup>
                        <InfoPopup id="star-code" text={TOOLTIPS_TEXT.STAR_CODES} />
                      </sup>
                    </Col>
                    <Col
                      sm={2}
                      style={{
                        display: 'flex',
                        verticalAlign: 'middle',
                      }}
                    >
                      {starToggleLoading ? (
                        <div>
                          <SpinnerCircles red />
                        </div>
                      ) : (
                        <Toggle
                          id="test-start-code-toggle"
                          disabled={boxOptions.starCodes}
                          value={boxOptions.starCodes}
                          onToggle={onStarCodeToggle}
                        />
                      )}
                    </Col>
                    {boxOptions.starCodes && (
                      <Col sm={2}>
                        {starResetLoading ? (
                          <Spinner customText={spinnerMsg} />
                        ) : (
                          <Button
                            color="primary"
                            onClick={handleStarReset}
                            id="test-start-code-reset-btn"
                          >
                            Reset
                          </Button>
                        )}
                      </Col>
                    )}
                  </Row>
                </div>
                {box?.modems.length < 2 && (
                  <div className="box-type-container col-md-10">
                    {parseInt(box?.vpnAddress?.split('.')[2]) > 20 && (
                      <Row>
                        <Col
                          sm={4}
                          id="test-sim-priority"
                          style={{ marginTop: '10px' }}
                          className="type-header d-flex"
                        >
                          SIM Priority
                          <sup>
                            <InfoPopup id="sim-prior" text={TOOLTIPS_TEXT.SIM_PRIOR} />
                          </sup>
                        </Col>
                        <Col sm={4}>
                          <DropdownSelect
                            disabled={!enableBoxEdit}
                            options={SIMItems}
                            selectedOption={simType}
                            onSelect={handleESIMSwapStatus}
                          />
                        </Col>
                        <Col sm={2}>
                          {simActiveLoading ? (
                            <Spinner customText={spinnerMsg} />
                          ) : (
                            <Button
                              color="primary"
                              onClick={handleActiveSim}
                              id="test-sim-priority-save-btn"
                            >
                              Save
                            </Button>
                          )}
                        </Col>
                        <Col sm={2}>
                          {!reloadSimStatus && (
                            <div
                              className="d-flex justify-content-flex-start align-items-center"
                              onClick={onReloadStatus}
                              id="test-reload-btn"
                            >
                              <i className="fa fa-redo reload-toggle"></i>
                            </div>
                          )}
                        </Col>
                      </Row>
                    )}
                    <Row className="mt-3">
                      <Col
                        sm={4}
                        // id="pricing-toggle-M"
                        className="type-header d-flex"
                        id="test-active-sim-label"
                      >
                        Active SIM:
                        <sup>
                          <InfoPopup id="active-sim" text={TOOLTIPS_TEXT.ACTIVE_SIM} />
                        </sup>
                      </Col>
                      <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                        <Input
                          id="test-active-sim-input"
                          type="text"
                          disabled
                          value={boxESimStatus ? 'SIM 2' : 'SIM 1'}
                        />
                      </Col>
                    </Row>
                  </div>
                )}
                <div className="box-type-container col-md-10">
                  <Row>
                    <Col
                      sm={4}
                      id="test-interface-priority-label"
                      style={{ marginTop: '10px' }}
                      className="type-header d-flex"
                    >
                      Interface Priority:
                      <sup>
                        <InfoPopup id="interface-prior" text={TOOLTIPS_TEXT.INTERFACE_PRIOR} />
                      </sup>
                    </Col>
                    {interfacePriority !== null ? (
                      <>
                        <Col sm={6} style={{ display: 'flex', verticalAlign: 'middle' }}>
                          <MultiInputDrag
                            type="interfacePriority"
                            inputData={interfacePriority}
                            move={move}
                            disabledAdmin
                          />
                        </Col>
                        <Col sm={2}>
                          <Button
                            color="primary"
                            onClick={handleInterfacePriority}
                            id="test-interface-priority-save-btn"
                          >
                            Save
                          </Button>
                        </Col>
                      </>
                    ) : (
                      <Col sm={8}>
                        <Alert style={{ width: '100%' }} color="info">
                          Priority could not be fetched
                        </Alert>
                      </Col>
                    )}
                  </Row>
                </div>

                {/* <div className="box-type-container col-md-10">
                  <Row>
                    <Col sm={4} id="pricing-toggle-M" className="type-header">
                      Enable E2:
                    </Col>
                    <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <Toggle
                        value={boxOptions.e3}
                        onToggle={() => {
                          onE3Toggle();
                        }}
                      />
                    </Col>
                  </Row>
                </div> */}

                <div className="box-type-container col-md-10">
                  <Row>
                    <Col
                      sm={4}
                      id="test-apn"
                      style={{ marginTop: '10px' }}
                      className="type-header d-flex"
                    >
                      Active Carrier:
                      <sup>
                        <InfoPopup id="apn" text={TOOLTIPS_TEXT.ACTIVE_CARRIER} />
                      </sup>
                    </Col>
                    {activeCarrier ? (
                      <Col sm={8}>
                        <Input
                          id="active-carrier-input"
                          type="text"
                          disabled
                          value={activeCarrier}
                        />
                      </Col>
                    ) : (
                      <div>
                        <SpinnerCircles red />
                      </div>
                    )}
                  </Row>
                </div>
                <div className="box-type-container col-md-10">
                  <Row>
                    <Col
                      sm={4}
                      // id="pricing-toggle-M"
                      className="type-header d-flex"
                      id="test-current-vpn-label"
                    >
                      Current APN:
                      <sup>
                        <InfoPopup id="current-apn" text={TOOLTIPS_TEXT.CURRENT_APN} />
                      </sup>
                    </Col>
                    <Col sm={8} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <Input
                        id="test-current-vpn-input"
                        type="text"
                        disabled
                        value={APNCurrentString}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="box-type-container col-md-10">
                  <Row>
                    <Col
                      sm={3}
                      id="test-apn-management"
                      style={{ marginTop: '10px' }}
                      className="type-header d-flex"
                    >
                      Set APN For:
                      <sup>
                        <InfoPopup id="apn-management" text={TOOLTIPS_TEXT.APN_MANAGEMENT} />
                      </sup>
                    </Col>
                    <Col sm={3}>
                      <DropdownSelect
                        placeholder="Please select Carrier"
                        disabled={!enableBoxEdit}
                        options={APNItems}
                        selectedOption={{
                          label: newActiveCarrier?.toUpperCase(),
                          value: newActiveCarrier,
                        }}
                        onSelect={value => {
                          setNewActiveCarrier(value.value);
                          setNewActiveCarrierAPN('');
                          setCustomApn(false);
                        }}
                      />
                    </Col>
                    <Col sm={4}>
                      {customApn ? (
                        <Input
                          id="test-custom-apn-input"
                          type="text"
                          defaultValue={newActiveCarrierAPN}
                          onChange={ev => {
                            setAPNString(ev?.target?.value);
                            setNewActiveCarrierAPN(ev?.target?.value);
                          }}
                        />
                      ) : (
                        <DropdownSelect
                          placeholder="Please select APN"
                          disabled={!newActiveCarrier}
                          options={carrierAPNs[newActiveCarrier] || carrierAPNs.verizon}
                          selectedOption={{
                            label:
                              newActiveCarrierAPN?.toUpperCase() || carrierAPNs?.verizon[0]?.label,
                            value: newActiveCarrierAPN || carrierAPNs?.verizon[0]?.value,
                          }}
                          onSelect={value => {
                            if (value?.value === 'custom') {
                              setCustomApn(true);
                              setNewActiveCarrierAPN('');
                            } else {
                              setAPNString(value.value);
                              setNewActiveCarrierAPN(value.value);
                            }
                          }}
                        />
                      )}
                    </Col>
                    <Col sm={2}>
                      <Button
                        disabled={!newActiveCarrierAPN}
                        color="primary"
                        onClick={handleSetCarrier}
                        id="test-apn-save-btn"
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                </div>
              </>
            ) : null}
            {!box?.myEpik && (
              <div className="box-type-container col-md-10">
                <Row>
                  <Col id="call-recording-toggle" sm={5} className="type-header d-flex">
                    Enable Call Recording:
                    <sup>
                      <InfoPopup id="enable-call" text={TOOLTIPS_TEXT.ENABLE_CALL_RECOR} />
                    </sup>
                  </Col>

                  {isCallRecorderLoading ? (
                    <div>
                      <SpinnerCircles red />
                    </div>
                  ) : (
                    <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                      <Toggle
                        id="test-call-recording-toggle"
                        value={boxOptions.recording}
                        onToggle={onCallRecordingToggle}
                      />
                    </Col>
                  )}
                </Row>
              </div>
            )}
            <div className="box-type-container col-md-10">
              <Row>
                <Col id="test-epi-provisioning-label" sm={5} className="type-header d-flex">
                  epik EPI provisioning:
                  <sup>
                    <InfoPopup id="epi-prov" text={TOOLTIPS_TEXT.EPIK_PROV} />
                  </sup>
                </Col>
                {!enableInhouseToggler ? (
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      id="test-epi-provisioning-toggle"
                      value={boxOptions.inhouseProvision}
                      onToggle={HandleInHousingToggle}
                    />
                  </Col>
                ) : (
                  <div>
                    <SpinnerCircles red />
                  </div>
                )}
              </Row>
            </div>
            {!box?.myEpik && checkThirdOctet && !isModelGen4 && (
              <div className="box-type-container col-md-10">
                <Row>
                  <Col sm={5} id="test-enable-sip-pri-label" className="type-header d-flex">
                    Enable SIP | PRI:
                    <sup>
                      <InfoPopup id="enable-sip" text={TOOLTIPS_TEXT.ENABLE_SIP} />
                    </sup>
                  </Col>
                  <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                    <Toggle
                      id="test-enable-sip-pri-toggle"
                      value={box?.features?.showPriTab}
                      onToggle={handlePriSip}
                    />
                  </Col>
                </Row>
              </div>
            )}
            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="test-enable-sip-pri-label" className="type-header d-flex">
                  Data Center Auto Select:
                  <sup>
                    <InfoPopup id="dc-auto-switch" text={TOOLTIPS_TEXT.DC_AUTO_SWITCH} />
                  </sup>
                </Col>
                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    id="dc-auto-switch-toggle"
                    value={box?.features?.dcAutoUpdate}
                    onToggle={async () => {
                      if (!box?.features?.dcAutoUpdate) {
                        setCurrentModalData({ type: 'dcAutoUpdate' });
                        setPasswordModalStatus(true);
                      } else {
                        handleDcAutoUpdateToggle();
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
            <div className="box-type-container col-md-10">
              <Row>
                <Col sm={5} id="test-enable-sip-pri-label" className="type-header d-flex">
                  Allow International Dialing:
                  <sup>
                    <InfoPopup id="international-dialing" text={TOOLTIPS_TEXT.INTERNATIONAL_DIALING} />
                  </sup>
                </Col>
                <Col sm={2} style={{ display: 'flex', verticalAlign: 'middle' }}>
                  <Toggle
                    id="international-dialing-toggle"
                      value={interDialing}
                    onToggle={async () => {
                      setCurrentModalData({ type: 'internationalDialing' });
                      setPasswordModalStatus(true);
                    }}
                  />
                </Col>
              </Row>
            </div>
            <div className="box-type-container col-md-10">
              <Row style={{ alignItems: 'self-end' }}>
                <Col sm={4} id="test-enable-sip-pri-label" className="type-header d-flex">
                  Data Center:
                  <sup>
                    <InfoPopup id="data-center" text={TOOLTIPS_TEXT.DATA_CENTER} />
                  </sup>
                </Col>

                <Col
                  sm={6}
                  style={{
                    display: 'flex',
                    gap: '5px',
                    whiteSpace: 'noWrap',
                    alignItems: 'flex-end',
                  }}
                >
                  <div>
                    {dcLoading ? (
                      <SpinnerCircles red />
                    ) : (
                      <DropdownSelect
                        options={dcOptionsWithLatency}
                        selectedOption={dc}
                        onSelect={value => {
                          onDataCenterSelection(value);
                        }}
                      />
                    )}
                  </div>
                  <div className="last-update-box">
                    <p className="last-update-label">
                      {centerLatencyState?.data?.timeUpdated &&
                        `Last Updated : ${utils.getDateTimeFormat(centerLatencyState?.data?.timeUpdated, 'both')}`}
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        verticalAlign: 'middle',
                        gap: '5px',
                        whiteSpace: 'noWrap',
                      }}
                    >
                      <Button color="primary" onClick={onCommit} id="test-sim-priority-save-btn">
                        Commit
                      </Button>

                      <Button color="primary" onClick={onUpdateDC} id="test-sim-priority-save-btn">
                        Update Latency
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          <ConfirmationModal
            bodyText={
              'You are about to move this device to a data center with slower latency. Are you sure you want to continue?'
            }
            confirmBtnText={'Continue'}
            isOpen={dcUpdatePopup.show}
            onCancel={() => {
              setDcUpdatePopup({ show: false, value: {} });
              setDc(datacenters.find(dc => dc.value === box?.datacenter));
            }}
            onConfirm={() => {
              setDcUpdatePopup({ show: false, value: {} });
              setCurrentModalData(datacenterWarningText);
              setWarningStatus(true);
            }}
          />

          {!box.myEpik && (
            <div className="reboot-btn-footer">
              {/* {interfacePriority === null && (
                <Button
                  id="test-fail-over-btn"
                  className="options-btns"
                  disabled={failoverStatus}
                  color="primary"
                  onClick={onFailoverPress}
                >
                  Failover Install
                </Button>
              )} */}
            </div>
          )}
          <CustomModal
            header="Device Updates"
            isOpen={isUpdateBtnDisable}
            onCancel={() => setIsUpdateBtnDisable(false)}
            close={true}
            submitDisplay
          >
            EPIK Updates have been disabled by Engineering for this Device.
          </CustomModal>

          {showWarningModel && (
            <BandManagementWarningModal
              headText={`Out of band management`}
              isOpen={showWarningModel}
              goHandler={warningGoHandler}
              cancelHandler={warningCancelHandler}
              loading={oobLoading}
            />
          )}

          <div className="epiFooter bottom-btn d-flex justify-content-between">
            <div className="d-flex">
              <Button
                hidden={
                  !['superAdmin', 'companyGroupAdmin', 'supportEngineer'].some(
                    x => x === user.role,
                  ) || box?.myEpik
                }
                className="opt-btns"
                color="default"
                onClick={onHardReset}
              >
                <img
                  id="test-power-cycle-btn"
                  style={{ width: '35px' }}
                  src={powerCycle}
                  alt="power"
                />
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpenPower}
                  target="test-power-cycle-btn"
                  toggle={toggleTooltipPower}
                >
                  Power Cycle
                </Tooltip>
              </Button>
              <Button
                disabled={!enableBoxEdit}
                className="opt-btns"
                color="default"
                onClick={saveOptions}
              >
                <img id="test-save-btn" style={{ width: '35px' }} src={save} alt="power" />
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpenSave}
                  target="test-save-btn"
                  toggle={toggleTooltipSave}
                >
                  Save
                </Tooltip>
              </Button>
              <Button
                hidden={
                  (user.role !== 'superAdmin' && user.role !== 'companyGroupAdmin') || box?.myEpik
                }
                color="default"
                className="opt-btns"
                id="test-suspend-restore-btn"
                onClick={async () => {
                  {
                    box?.enabled
                      ? setCurrentModalData(suspendedTxt)
                      : setCurrentModalData(restoreSuspension);
                  }
                  setWarningStatus(true);
                }}
              >
                <img style={{ width: '35px' }} src={suspend} alt="power" />
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpenSuspend}
                  target="test-suspend-restore-btn"
                  toggle={toggleTooltipSuspend}
                >
                  {box?.enabled ? 'Suspend Service' : 'Restore Service'}
                </Tooltip>
              </Button>
              <Button className="opt-btns" color="default" onClick={onReboot}>
                <img
                  id="test-soft-reboot-btn"
                  style={{ width: '35px' }}
                  src={softReboot}
                  alt="power"
                />
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpenSoft}
                  target="test-soft-reboot-btn"
                  toggle={toggleTooltipSoft}
                >
                  Soft Reboot
                </Tooltip>
              </Button>
            </div>
            <div className="last-update-box">
              <Button
                // color={box?.epikUpdateStatus ? 'secondary' : 'primary'}
                className="opt-btns opt-update"
                color="default"
                onClick={box?.epikUpdateStatus ? handleUpdateBtnFunc : onApplyUpdate}
              >
                <img
                  id="test-apply-updates-btn"
                  style={{ width: '35px' }}
                  src={applyUpdates}
                  alt="power"
                />
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpenUpdate}
                  target="test-apply-updates-btn"
                  toggle={toggleTooltipUpdate}
                >
                  Apply Updates
                </Tooltip>
              </Button>
              <p className="last-update-label">{`Last Manually Updated: ${utils.getDateTimeFormat(box?.firmwareUpdatedOn, 'both')}`}</p>
            </div>
          </div>
        </>
      )}

      <CustomModal
        showCustomButton
        customButtonText="Ok"
        header="Alert"
        isOpen={recordingModal}
        onCancel={() => {
          setIsExpandingBox(false);
          setRecordingModal(false);
        }}
      >
        Recording will be kept for 14 days
      </CustomModal>

      <ConfirmationModal
        isOpen={warningStatus}
        onCancel={() => {
          setWarningStatus(false);
          setIsExpandingBox(false);
        }}
        confirmBtnText={currentModalData.type === 'datacenter' ? "Move" : currentModalData.type === 'suspension2' ? 'Suspend' : false}
        bodyText={currentModalData.msg}
        subHeader={currentModalData.type === 'datacenter' ? currentModalData?.subHeader : null}
        headerText={currentModalData.type === 'datacenter' ? currentModalData?.header : null}
        onConfirm={async () => {
          if (currentModalData.type === 'datacenter') {
            const ports = obisToPort(box?.Obis, box?.lastUpdated);
            if (ports.some(p => ['fax', 'faxStandard'].includes(p.serviceName)) && dc.value === 'ch')
              setNumberConfirmation(true);

            onPassSecurityModal();
            // setPasswordModalStatus(true);
            setWarningStatus(false);
          } else if (currentModalData.type === 'enhancedFax') {
            setWarningStatus(false);
            const res = await updateBox(token, {
              ...boxOptions,
              enhancedFax: true,
            });
            if (res) {
              // [Action] - Change
              changeAction('enhancedFax changed');
            }
          } else if (
            currentModalData.type === 'monitoring' ||
            currentModalData.type === 'advancedMonitoring'
          ) {
            openPasswordModal();
          } else if (
            currentModalData.type === 'suspension1' ||
            currentModalData.type === 'suspension2'
          ) {
            setSuspendModal(currentModalData.type === 'suspension1');
            setWarningStatus(false);
            if (currentModalData.type === 'suspension2') {
              const obj = {
                note,
                type: 'user',
              };
              const autoNote = {
                note: `Service Suspended by ${user.name}`,
                type: 'system',
              };

              const res = await updateBox(token, {
                ...boxOptions,
                enabled: false,
                integrated: false,
                refreshSuspendedDate: true,
              });
              if (res) addNote(token, box._id, obj);
              if (res) addNote(token, box._id, autoNote);
              if (res) {
                // [Action] - Change
                changeAction('Service Suspended');
              }
            }
            setWarningStatus(false);
          } else if (currentModalData.type === 'restore') {
            const obj = {
              note: `Service Restored by ${user.name}`,
              type: 'system',
            };
            const res = await updateBox(token, {
              ...boxOptions,
              enabled: true,
              refreshSuspendedDate: true,
            });
            if (res) addNote(token, box._id, obj);
            if (res) {
              // [Action] - Change
              changeAction('Service restored');
            }
            setWarningStatus(false);
          } else if (currentModalData.type === 'hardReset') {
            setWarningStatus(false);
            // setIsExpandingBox(true);
            const res = await boxHardReset(token, box?.vpnAddress);
            if (res) {
              // [Action] - Enable
              await enableAction('Hard Reset');
            }
            // setIsExpandingBox(false);
          } else if (currentModalData.type === 'disableEnhancedFax') {
            const res = await updateBox(token, {
              ...boxOptions,
              enhancedFax: false,
            });
            if (res) {
              // [Action] - Change
              changeAction('enhancedFax changed');
              setWarningStatus(false);
            }
          } else {
            onWarningConfirm();
          }
        }}
      />
      <CustomModal
        confirmBtnText={'Save'}
        isOpen={suspendModal}
        onCancel={() => setSuspendModal(false)}
        onConfirm={() => {
          setWarningStatus(true);
          setCurrentModalData(suspendedTxt1);
        }}
      >
        <FormGroup row>
          <Col>
            <Label>Reason For Suspension</Label>
            <Input
              required
              type="textarea"
              name="suspensionNote"
              placeholder="Enter Note"
              value={note}
              onChange={e => setSuspensionNote(e.target.value)}
            />
          </Col>
        </FormGroup>
      </CustomModal>
      <AddSecurityCodeModal
        isOpen={passwordModalStatus}
        onConfirm={onPassSecurityModal}
        onCancel={() => {
          setWarningStatus(false);
          setCurrentModalData({});
          setPasswordModalStatus(false);
          setIsExpandingBox(false);
        }}
        // modalname='secondarytunneltoggle  scndrytnlupdate'
        // modalname='monitoring, advanceMonitering'
        featureName={getPinCodeName()}
      />
      {numberConfirmation && (
        <WarningModal
          body={
            'Faxing services will be migrated to the Enhanced Fax protocol. Fax services may be interrupted during the migration process. Validate all fax settings after the migration is complete. Do you want to proceed?'
          }
          isOpen={numberConfirmation}
          onCancel={() => {
            setCurrentModalData({});
            setWarningStatus(false);
            setPasswordModalStatus(false);
            setNumberConfirmation(false);
          }}
          onConfirm={() => {
            setNumberConfirmation(false);
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  companies: state.AppState.companies,
  editCompanyGroupData: state.UIState.companies.editCompanyGroupData || '',
  boxesSerial: state.AppState.boxesSerial,
  centerLatency: state.AppState.boxDetails.dataCenterLatency,
  boxesList: state.AppState.boxes,
  optionsBoxUpdate: state.UIState.epikBoxes.optionsBoxUpdate.optionsBox,
  addressModalData: state.AppState.provisioning.address,
  box: state.AppState.boxDetails.box,
  user: state.AppState.user,
  lockStatusBox: state.UIState.epikBoxes.lockStatusEpikBox,
  boxESimStatus: state.UIState.epikBoxes.boxESimStatus,
  assignedNumbers: state.AppState.obis.assignedNumbers,
});

const mapDispatchToProps = dispatch => ({
  editOptionsChange: (name, value) => dispatch(BoxesActions.editOptionsChange(name, value)),
  optionsBoxChange: boxData => dispatch(BoxesActions.optionsBoxChange(boxData)),
  getBoxesSerialNumber: (token, boxId) => dispatch(BoxesActions.getEpikBoxesSerial(token, boxId)),
  updateAddress: (token, numId, body) => dispatch(updateAddress(token, numId, body)),
  setInterfacePriority: (token, vpn, value) => dispatch(BoxesActions.setInterfacePriority(token, vpn, value)),
  boxHardReset: (token, vpn) => dispatch(BoxesActions.boxHardReset(token, vpn)),
  getInterfacePriority: (token, vpn) => dispatch(BoxesActions.getInterfacePriority(token, vpn)),
  setCarrier: (token, vpn, value) => dispatch(BoxesActions.setCarrier(token, vpn, value)),
  getCarrier: (token, vpn, carrier) => dispatch(BoxesActions.getCarrier(token, vpn, carrier)),
  getCurrentApn: (token, vpn) => dispatch(BoxesActions.getCurrentApn(token, vpn)),
  getAddress: (token, numId) => dispatch(getAddress(token, numId)),
  clearAddress: () => dispatch(clearAddress()),
  updateBox: (token, box) => dispatch(BoxesActions.updateEpikBox(token, box)),
  updateInterCalling: (token, bid, body) => dispatch(BoxesActions.updateInterCalling(token, bid, body)),
  activateE2: (token, boxId, body) => dispatch(BoxesActions.activateE2(token, boxId, body)),
  deactivateE2: (token, boxId) => dispatch(BoxesActions.deactivateE2(token, boxId)),
  activateE3: (token, boxId) => dispatch(BoxesActions.activateE3(token, boxId)),
  deactivateE3: (token, boxId) => dispatch(BoxesActions.deactivateE3(token, boxId)),
  enableRecording: (token, boxId) => dispatch(BoxesActions.enableRecording(token, boxId)),
  disableRecording: (token, boxId) => dispatch(BoxesActions.disableRecording(token, boxId)),
  addAction: description => dispatch(addAction(description)),
  disableAction: description => dispatch(disableAction(description)),
  enableAction: description => dispatch(enableAction(description)),
  changeAction: description => dispatch(changeAction(description)),
  addNote: (token, id, note) => dispatch(BoxesActions.addNote(token, id, note)),
  getEpikBoxesBySerialNumber: (token, serialNumber, online, pagination) =>
    dispatch(BoxesActions.getEpikBoxesBySerialNumber(token, serialNumber, online, pagination)),
  boxLock: (token, bid) => dispatch(BoxesActions.boxLock(token, bid)),
  eSIMStatus: (token, bid) => dispatch(BoxesActions.eSIMStatus(token, bid)),
  eSIMStatusSwap: (token, eSIMStatusValue, bid) =>
    dispatch(BoxesActions.eSIMStatusSwap(token, eSIMStatusValue, bid)),
  secondaryTunnel: (token, boxId, secTunnel) => dispatch(BoxesActions.secondaryTunnel(token, boxId, secTunnel)),
  secondaryTunnelStatus: (token, boxId) => dispatch(BoxesActions.secondaryTunnelStatus(token, boxId)),
  enableStarCodes: (token, boxId) => dispatch(BoxesActions.enableStarCodes(token, boxId)),
  enableBoxCallForward: (token, boxId, callForwardEnable, callForwardNumber) => dispatch(BoxesActions.enableBoxCallForward(token, boxId, callForwardEnable, callForwardNumber)),
  resetStarCodes: (token, boxId) => dispatch(BoxesActions.resetStarCodes(token, boxId)),
  boxActiveSimStats: (token, boxId) => dispatch(BoxesActions.boxActiveSimStats(token, boxId)),
  getBoxConnectedUsb: (token, boxId, vpnAddress) => dispatch(BoxesActions.getBoxConnectedUsbs(token, boxId, vpnAddress)),
  removeOob: (token, params) => dispatch(BoxesActions.removeOob(token, params)),
  updateOOBDetail: (token, params) => dispatch(BoxesActions.updateOOBDetail(token, params)),
  ext_9override: (token, vpnAddress, extValue) => dispatch(BoxesActions.ext_9override(token, vpnAddress, extValue)),
  updateDbcaAlert: (token, boxId, dbcaValue) => dispatch(BoxesActions.updateDbcaAlert(token, boxId, dbcaValue)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EpikboxOptions);
